import { DataLayer } from '@/shared/services/gtm/models/models-gtm'

export class FilmTrailerDataLayer extends DataLayer {
    public film_id: string
    public film_name: string

    public constructor(params: {
        film_id: string
        film_name: string
        uniqueEventId?: number
        element?: string
        customerId?: string | null
    }) {
        super('trailer_open', params.uniqueEventId, params.element)

        this.film_id = params.film_id
        this.film_name = params.film_name
        this.customerId = params.customerId
    }
}
